export default Intl.NumberFormat('en-US').format;
